<template>
  <div class="hello" :spinning="loading">
    <div class="flex-sb">
      <div class="img-container">
        <img :src="initImg" ref="image" alt="" />
      </div>
      <div class="ml20">
        <p>预览</p>
        <div class="before"></div>
      </div>
    </div>
    <a-button slot="footer" style="margin-top: 30px" type="error" @click="sureSava">裁剪</a-button>
  </div>
</template>

<script>
import Cropper from 'cropperjs'
import { base64ToFile } from '@/utils/util'
import compuedFun from '../../computed/'
import 'cropperjs/dist/cropper.css'
import api from '@/api/'
import { set } from '@vue/composition-api'

const { QI_NIU_DOMAINS } = compuedFun()

export default {
  name: 'HelloWorld',
  props: {
    initImg: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data () {
    return {
      loading: true,
      myCropper: null,
      afterImg: ''
    }
  },
  created() {
    const _this = this
    window.onload = function() {
      _this.loading = false
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.myCropper = new Cropper(this.$refs.image, {
        viewMode: 1,
        dragMode: 'none',
        initialAspectRatio: 1,
        aspectRatio: 1,
        preview: '.before',
        background: false,
        autoCropArea: 0.6,
        zoomOnWheel: false
      })
    },
    sureSava() {
      this.afterImg = this.myCropper.getCroppedCanvas({
        imageSmoothingQuality: 'high'
      }).toDataURL('image/jpeg')

      const blob = base64ToFile(this.afterImg, 'image/png')
      const fileBlob = new FormData()
      fileBlob.append('file', blob)
      api.QiniuFile(fileBlob).then((res) => {
        this.$emit('handleTailorOver', { path: res.data.url, url: this.afterImg })
      })
    }
  }
}
</script>

<style scoped>
.container{
  display: flex;
}
.before{
  width: 100px;
  height: 100px;
  overflow: hidden;
}
.img-container{
  height: 400px;
  overflow: hidden;
}
</style>
